import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const InstallCompletedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.INSTALL_COMPLETED),
  bills: z
    .array(
      z.object({
        billId: z.string().nullable(),
        amount: z.number(),
        receiptFileIds: z.array(z.string()),
        payeeId: z.string(),
      }),
    )
    .nullable(),
  installCompletedAt: z.coerce.date(),
});
